import { FormattedNumber, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import firstPlace from '@sorare/core/src/components/rivals/Seasons/PodiumIcon/assets/firstPlace.png';
import secondPlace from '@sorare/core/src/components/rivals/Seasons/PodiumIcon/assets/secondPlace.png';
import thirdPlace from '@sorare/core/src/components/rivals/Seasons/PodiumIcon/assets/thirdPlace.png';
import { Diamond } from '@sorare/core/src/components/rivals/branded/Diamond';
import { getTextSize } from '@sorare/core/src/lib/text';

const Root = styled(Horizontal).attrs({ center: true })`
  position: relative;
  width: calc(5 * var(--unit));
  height: calc(5 * var(--unit));
  isolation: isolate;
`;

const Svg = styled.svg`
  width: 100%;
  height: 100%;
`;

const AbsoluteImg = styled.img`
  position: absolute;
  inset: 0;
  height: 100%;
  z-index: -1;
  object-fit: contain;
  filter: drop-shadow(0 5px 3px var(--c-neutral-100));
`;

type Props = { rank: Nullable<number>; size?: number };

export const DiamondWrapper = ({
  text,
  size = 40,
}: {
  text: string;
  size?: number;
}) => {
  const { width: viewPortSize } = getTextSize(
    text,
    `700 16px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif`
  );
  return (
    <Diamond
      width={size}
      height={size}
      noFilter
      color="var(--c-rivals-purple-600)"
    >
      <Svg viewBox={`0 0 ${viewPortSize + 32} 16`}>
        <text x="16" y="14" fill="currentColor" fontWeight="700">
          {text}
        </text>
      </Svg>
    </Diamond>
  );
};

export const LeaguePodiumIcon = ({ rank, size }: Props) => {
  const { formatNumber } = useIntl();
  let src = firstPlace;

  if (rank === 2) {
    src = secondPlace;
  }
  if (rank === 3) {
    src = thirdPlace;
  }
  if (!rank) {
    return <DiamondWrapper text="-" />;
  }
  const onPodium = rank <= 3;

  if (onPodium) {
    return (
      <Root>
        <AbsoluteImg src={src} />
        <LabelL bold as="span">
          <FormattedNumber value={rank} />
        </LabelL>
      </Root>
    );
  }

  return <DiamondWrapper text={formatNumber(rank)} size={size} />;
};
